<!--
 * @Description: 电子账簿信息 
 * @Date: 2025-05-20 18:01:30
-->

<template>
  <div class="account-info__items">
    <BaseTextTitle class="account-info__items__title">
      电子账簿信息
    </BaseTextTitle>
    <BaseTextContent style="padding-top: 0">
      <BaseTable :data="tableData" :columns="columns" />
    </BaseTextContent>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue';
import {
  BaseTable,
  BaseTextContent,
  BaseTextTitle,
  useTableColumn
} from 'xrk-components';
import { storeToRefs } from 'pinia';
import infoStore from '../../store/info';

const { formData } = storeToRefs(infoStore());
const tableData = ref([]);

watch(
  () => formData.value,
  val => {
    const { electronicLedgerInformation } = val;
    const _data = [
      {
        type: '入金账户',
        openBankName: electronicLedgerInformation.fyOpenBankName,
        accountNumber: electronicLedgerInformation.fyAccountNumber,
        subBranchName: electronicLedgerInformation.fySubBranchName,
        interBankNo: electronicLedgerInformation.fyInterBankNo
      },
      {
        type: '收支账户/富友ID',
        openBankName: electronicLedgerInformation.fyPaymentAccountName,
        accountNumber: electronicLedgerInformation.fyPaymentAccountNo,
        subBranchName: electronicLedgerInformation.fyPaymentAccountBranchName,
        interBankNo: ''
      },
      {
        type: '银行电子户信息',
        openBankName: electronicLedgerInformation.fyBankPortBankName,
        accountNumber: electronicLedgerInformation.fyBankPortBankNumber,
        subBranchName: '',
        interBankNo: ''
      }
    ];
    tableData.value = _data;
  },
  { once: true }
);

const columns = [
  useTableColumn({
    label: '类型',
    prop: 'type'
  }),
  useTableColumn({
    label: '开户行',
    prop: 'openBankName'
  }),
  useTableColumn({
    label: '账号',
    prop: 'accountNumber'
  }),
  useTableColumn({
    label: '支行名称',
    prop: 'subBranchName'
  }),
  useTableColumn({
    label: '联行号',
    prop: 'interBankNo'
  })
];
</script>
